import React, { Component } from 'react';
import { Collapse, ControlLabel, FormControl, Glyphicon, FormGroup, InputGroup, HelpBlock } from 'react-bootstrap';
import { CCOAlert, FieldGroup, CCOButton } from './util/Components.js';
import { clone, update } from './util/Utility.js';
import firebaseLocal from 'firebase';
import { BeatLoader } from 'react-spinners';


export default class Profile extends Component {

  constructor(props) {
    super(props);

    this.state = {
      leader: null,
      baseLeader: null,
      emailAlert: false,
      resetEmailSent: false,
      newEmailSuccessAlert: false,
      newEmailAlert: false,
      newEmail: ""
    };

    window.base.fetch('leaders/' + this.props.user.uid, {
      context: this,
      asArray: false,
    }).then(data => {
      this.setState({leader: clone(data), baseLeader: clone(data)});
    }).catch(() => {
      console.log("error getting leader");
    });
  }

  validateEmail(email) {
    var re = /^.+@.+\..{2,3}$/;
    return re.test(email);
  }

  save() {
    if (!this.validateEmail(this.state.leader.email)) {
      this.setState({emailAlert: true});
    }
    else {

      let leader = this.state.leader;
      update('leaders/' + this.props.user.uid, this, leader).then(function() {
        this.setState({/*phoneAlert: false, */emailAlert: false, baseLeader: clone(this.state.leader)});
      }.bind(this));
    }
  }

  emailChange(e) {
    let leader = this.state.leader;
    leader.email = e.target.value;
    this.setState({leader: leader, emailAlert: false});
  }

  // phoneChange(e) {
  //   let leader = this.state.leader;
  //   leader.phone = e.target.value;
  //   this.setState({leader: leader, phoneAlert: false});
  // }

  render() {

    // <FormGroup>
    //   <InputGroup>
    //     <InputGroup.Addon><Glyphicon glyph="earphone" /></InputGroup.Addon>
    //     <FormControl placeholder="Enter Phone Number" type="text" value={this.state.leader.phone} onChange={this.phoneChange.bind(this)} />
    //   </InputGroup>
    // </FormGroup>

    // <CCOAlert in={this.state.phoneAlert} type="danger" title="Bad Phone Number Format" content="Please enter a valid, ten digit phone number." />


    if (this.state.leader == null) {
      return null;
    }

    return (
      <center>
        <div style={{maxWidth: 500, padding: 10}}>

          <div style={{maxWidth: 400}}>
            <ControlLabel color="black">Contact Details</ControlLabel>

            <FormGroup>
              <InputGroup>
                <InputGroup.Addon><Glyphicon glyph="envelope" /></InputGroup.Addon>
                <FormControl placeholder="Enter Email" type="text" value={this.state.leader.email} onChange={this.emailChange.bind(this)} />
              </InputGroup>
              <HelpBlock>Note: This email will be publically available, use your @ccorl.com email if you have one, or an email you do not mind everyone who downloads the app seeing.</HelpBlock>
            </FormGroup>

            <CCOAlert in={this.state.emailAlert} type="danger" title="Bad Email Format" content="Please enter a valid email address." />
          </div>

          <div style={{height: 10}} />
          <FieldGroup id="bio" label="My Bio" rows={6} placeholder="Enter a few sentences about yourself and your role at CCO" context={this} comp="leader" componentClass="textarea" />

          <Collapse style={{width: 200}} in={JSON.stringify(this.state.leader) !== JSON.stringify(this.state.baseLeader)}><div>
            <CCOButton type="primary" onClick={this.save.bind(this)} text="Save Changes" />
          </div></Collapse>

          <div style={{height: 30}} />
          <div style={{maxWidth: 250}}>
            <ChangePassword user={this.props.user} />
            <div style={{height: 30}} />
            <ChangeLoginEmail user={this.props.user} />
          </div>
        </div>
      </center>
    );
  }
}

class ChangePassword extends Component {
  constructor(props) {
    super(props)

    this.state = {
      newPassword: "",
      newPassword2: "",
      currentPassword: "",
      loading: false,
      alert: {
        in: false
      }
    }
  }

  changePassword() {
    this.setState({alert: {in: false}, loading: true});
    if (this.state.newPassword !== "" && this.state.currentPassword !== "" &&this.state.newPassword2 !== "") {
      if (this.state.newPassword === this.state.newPassword2) {
        const credential = firebaseLocal.auth.EmailAuthProvider.credential(
          this.props.user.email,
          this.state.currentPassword
        );
        this.props.user.reauthenticateWithCredential(credential).then(() => {
          this.props.user.updatePassword(this.state.newPassword).then(() => {
            this.setState({newPassword: "", newPassword2: "", currentPassword: "", loading: false, alert: {in: true, type: "success", title: "Password Updated Successfully", content: "Don't forget to use your new password next time you log in."}});
          }).catch(error => {
            if (error.code === "auth/weak-password")
              this.setState({loading: false, alert: {in: true, type: "warning", title: "Insecure Password", content: "Passwords must be at least 6 characters long"}});
            else {
              console.warn(error);
              window.show("error", "Unexpected Error", error.code);
              this.setState({loading: false});
            }
          });
        }).catch(error => {
          if (error.code === "auth/wrong-password")
            this.setState({loading: false, alert: {in: true, type: "danger", title: "Incorrect Password", content: "Please make sure you entered your current password correctly."}});
          else {
            window.show("error", "Unexpected Error", error.code);
            this.setState({loading: false});
          }
        });
      } else {
        this.setState({loading: false, alert: {in: true, type: "warning", title: "Password Do Not Match", content: "Please enter the same new password twice"}});
      }
    } else {
      this.setState({loading: false, alert: {in: true, type: "warning", title: "Empty Password(s)", content: "Please enter your current and new password"}});
    }
  }

  render() {
    return (
      <div style={{maxWidth: 300}}>
        <form onSubmit={evt => {
          this.changePassword();
          evt.preventDefault();
        }}>
          <ControlLabel color="black">Change Password</ControlLabel>
          <FormControl placeholder="Enter New Password" type="password" value={this.state.newPassword} onChange={e => this.setState({newPassword: e.target.value})} />
          <div style={{height: 5}} />
          <FormControl placeholder="Repeat New Password" type="password" value={this.state.newPassword2} onChange={e => this.setState({newPassword2: e.target.value})} />
          <div style={{height: 5}} />
          <FormControl placeholder="Enter Current Password" type="password" value={this.state.currentPassword} onChange={e => this.setState({currentPassword: e.target.value})} />
          <div style={{height: 5}} />
          <CCOAlert {...this.state.alert} />
          <div style={{height: 5}} />
          {this.state.loading ? <BeatLoader loading size={10} color="black" /> : <CCOButton type="primary" onClick={() => this.changePassword()} text="Submit" />}
        </form>
      </div>
    )
  }
}

class ChangeLoginEmail extends Component {
  constructor(props) {
    super(props)

    this.state = {
      newEmail: "",
      currentPassword: "",
      loading: false,
      alert: {
        in: false
      }
    }
  }

  validateEmail(email) {
    var re = /^.+@.+\..{2,3}$/;
    return re.test(email);
  }

  updateLoginEmail() {
    this.setState({loading: true, alert: {in: false}});
    if (this.validateEmail(this.state.newEmail)) {
      if (this.state.currentPassword && this.state.currentPassword !== "") {
        const credential = firebaseLocal.auth.EmailAuthProvider.credential(
          this.props.user.email,
          this.state.currentPassword
        );
        this.props.user.reauthenticateWithCredential(credential).then(() => {
          this.props.user.updateEmail(this.state.newEmail).then(() => {
            this.props.user.sendEmailVerification().then(() => {
              this.setState({newEmail: "", currentPassword: "", loading: false, alert: {in: true, type: "success", title: "Email Updated Successfully", content: "Make sure to verify your new email by following the link that was sent to it, and sign in using the new email next time."}});
            }).catch(error => {
              this.setState({loading: false});
              console.warn(error);
            });
          }).catch(error => {
            if (error.code === "auth/email-already-in-use")
              this.setState({loading: false, alert: {in: true, type: "warning", title: "Email Already In Use", content: "Another user is already using that email, sorry!"}});
            else {
              console.warn(error);
              this.setState({loading: false});
              window.show("error", "Unexpected Error", error.code);
            }
          });
        }).catch(error => {
          if (error.code === "auth/wrong-password")
            this.setState({loading: false, alert: {in: true, type: "danger", title: "Incorrect Password", content: "Please make sure you entered your current password correctly."}});
          else {
            this.setState({loading: false});
            window.show("error", "Unexpected Error", error.code);
          }
        });
      } else {
        this.setState({loading: false, alert: {in: true, type: "warning", title: "Empty Password", content: "Please enter a password"}});
      }
    } else {
      this.setState({loading: false, alert: {in: true, type: "warning", title: "Invalid Email Format", content: "Please enter a valid email address."}});
    }
  }

  render() {
    return (
      <div style={{maxWidth: 300}}>
        <form onSubmit={evt => {
          this.updateLoginEmail();
          evt.preventDefault();
        }}>
          <ControlLabel color="black">Change Login Email</ControlLabel>
          <FormControl placeholder="Enter New Email" type="text" value={this.state.newEmail} onChange={e => this.setState({newEmail: e.target.value})} />
          <div style={{height: 5}} />
          <FormControl placeholder="Enter Current Password" type="password" value={this.state.currentPassword} onChange={e => this.setState({currentPassword: e.target.value})} />
          <div style={{height: 5}} />
          <CCOAlert {...this.state.alert} />
          <div style={{height: 5}} />
          {this.state.loading ? <BeatLoader loading size={10} color="black" /> : <CCOButton type="primary" onClick={() => this.updateLoginEmail()} text="Submit" />}
        </form>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/Profile.js
 **/